export default function ProgramSection() {
  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-white relative overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0a9e911319900678cba76da5718e4a72.jpg"
          alt="Dubai Creek Harbour"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 relative z-10">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-yellow-600/20 backdrop-blur-sm text-yellow-600 px-4 sm:px-6 py-2 rounded-full mb-6 sm:mb-8 border border-yellow-600/30">
            <i className="ri-map-pin-line text-lg sm:text-xl w-5 h-5 sm:w-6 sm:h-6 flex items-center justify-center"></i>
            <span className="font-light tracking-wide text-sm sm:text-base">Bereit für den nächsten Schritt?</span>
          </div>

          {/* Heading */}
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl xl:text-6xl mb-4 sm:mb-6 text-white leading-tight">
            Werden Sie Teil des Dubai Business Club
          </h2>

          {/* Description */}
          <p className="text-base sm:text-lg lg:text-xl text-white/80 mb-8 sm:mb-12 font-light leading-relaxed max-w-2xl">
            Wir laden Sie ein, sich für eine Mitgliedschaft zu bewerben. Nach Prüfung Ihrer Bewerbung erhalten Sie innerhalb von 7 Tagen eine persönliche Rückmeldung.
          </p>

          {/* Features */}
          <div className="grid sm:grid-cols-2 gap-4 sm:gap-6 mb-8 sm:mb-12">
            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center bg-yellow-600/20 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-yellow-600 text-sm"></i>
              </div>
              <div>
                <div className="text-white font-light text-sm sm:text-base">Exklusiver Zugang</div>
                <div className="text-white/60 text-xs sm:text-sm font-light">Keine offene Veranstaltung</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center bg-yellow-600/20 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-yellow-600 text-sm"></i>
              </div>
              <div>
                <div className="text-white font-light text-sm sm:text-base">Individuelle Prüfung</div>
                <div className="text-white/60 text-xs sm:text-sm font-light">Bewerbungsbasiert</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center bg-yellow-600/20 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-yellow-600 text-sm"></i>
              </div>
              <div>
                <div className="text-white font-light text-sm sm:text-base">Echte Substanz</div>
                <div className="text-white/60 text-xs sm:text-sm font-light">25 Jahre Erfahrung</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-6 h-6 flex items-center justify-center bg-yellow-600/20 rounded-full flex-shrink-0 mt-0.5">
                <i className="ri-check-line text-yellow-600 text-sm"></i>
              </div>
              <div>
                <div className="text-white font-light text-sm sm:text-base">Langfristig</div>
                <div className="text-white/60 text-xs sm:text-sm font-light">Lebenslange Community</div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <a
            href="#bewerbung"
            className="inline-flex items-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-yellow-600 text-black rounded-full hover:bg-yellow-500 transition-all duration-300 transform hover:scale-105 shadow-xl group whitespace-nowrap cursor-pointer text-sm sm:text-base"
          >
            <span className="font-light tracking-wide">Jetzt bewerben</span>
            <i className="ri-arrow-right-line text-lg sm:text-xl group-hover:translate-x-1 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
